import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { fetchpaymenthistory, formatToIndianRupees, setActivity } from '../../Global/Index';
import ClipLoader from 'react-spinners/ClipLoader';
import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@mui/material';

const override = {
    display: "block",
    margin: "10% auto",
    marginLeft: '44%'
};




export default function PaymentHistory() {
    const [showMore, setShowMore] = useState(false);
    const colors = ['b-danger', 'b-primary', 'b-warning', 'b-success', 'b-info'];
    const loandata = useSelector((state) => state.loan_data);
    const [history, setHistory] = useState(null);
    const theme = useTheme()




    useEffect(() => {
        const getData = async () => {
            try {
                await setActivity('Payment History Page');
            } catch (error) {
                console.log(error);
            }
            
            try {
                const resp = await fetchpaymenthistory();
                if (resp.response.status == "200" && resp.response.message == 'Success') {
                    setHistory(resp.response.data);
                } else if (resp.response.status === "419") {
                    window.location.href = '/Session-Expired'
                } else if (resp.response.status === "500") {
                    toast.error('Something went wrong. Please try again later!')
                } else if (resp.response.status === "503") {
                    toast.warn(resp.response.message);
                } else if (resp.response.status == '401') {
                    window.location.href = '/'
                }
            } catch (error) {
                console.error("Error fetching payment history:", error);
            }
        };

        getData();
    }, [loandata])


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const time = date.toISOString().slice(11, 19);


        if (dateString.includes('T')) {
            return `${day}-${month}-${year} ${time}`; // Return date with time
        } else {
            return `${day}-${month}-${year}`;
        }
    };





    const renderTimelineforpaymenthistory = () => {
        const limit = showMore ? history.length : 5; // Show all or limit to 5

        return history.slice(0, limit).map((event, index) => {
            const colorIndex = Math.floor(index / 2) % colors.length;
            const colorClass = colors[colorIndex];
            const isActive = index === 0 ? 'active' : '';

            return (
                <div className={`tl-item ${isActive}`} key={event.receiptNumber}> {/* Use a unique key */}
                    <div className={`tl-dot ${colorClass}`}></div>
                    <div className="tl-content" style={{ lineHeight: '1.3rem', marginLeft: '3vw' }}>
                        <div >Amount: </div>
                        <div>
                            <span style={{ fontSize: '1.6rem', fontWeight: '700' }}>{formatToIndianRupees(event.amount)}</span>
                        </div>
                        <div className="tl-date text-muted mt-1" ><span className='flexbasis'>Transaction Id: </span> {event.receiptNumber}</div>
                        <div className="tl-date text-muted mt-1"><span>Date:</span>{formatDate(event.dateOfCollection)}</div>
                        <div className="tl-date text-muted mt-1"><span>Purpose of payment: </span> {event.natureOfCollection}</div>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <ToastContainer />
            <div className="maincontainer" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
                <h2>Online Payment History</h2>
                <div>
                    <div className="page-content page-container" id="page-content">
                        <div className="padding">
                            <div className="row">
                                <div className="col-lg-6">
                                    {/* ..................................... */}
                                    <div className="timeline p-4 block mb-4">
                                        {renderContent()}
                                    </div>
                                    {/* ............................................................................................... */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    function renderContent() {
        if (!history) {
            return (
                <ClipLoader
                    color={theme.palette.maincolor.light}
                    loading={true}
                    cssOverride={override}
                    size={30}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            );
        }

        if (history.length > 0) {
            return (
                <>
                    {renderTimelineforpaymenthistory()}
                    <button
                        className="btnn btn-primary mt-3"
                        onClick={() => setShowMore(!showMore)}
                        style={{ background: theme.palette.maincolor.buttoncolor, color: theme.palette.maincolor.light }}
                    >
                        {showMore ? 'Show Less' : 'Show More'}
                    </button>
                </>
            );
        }

        return <p style={{ textAlign: 'center', color: 'red' }}>No Payment history found</p>;
    }
}
